import { UIText2 } from '@cian/ui-kit';
import styles from './ComparisonNotification.css';
import { ReactNode, FC } from 'react';

interface IComparisonNotificationProps {
  text: string;
  control: ReactNode;
  onMouseEnter(): void;
}

export const ComparisonNotification: FC<IComparisonNotificationProps> = ({ text, control, onMouseEnter }) => {
  return (
    <div className={styles['container']} onMouseEnter={onMouseEnter}>
      <div className={styles['notification']}>
        <UIText2 whiteSpace="pre-line" color="text-inverted-default">
          {text}
        </UIText2>
        <div className={styles['control']}>{control}</div>
      </div>
    </div>
  );
};
